import destroy from './destroy';
import store from './store';
import show from './show';
import update from './update';
import all from './all';
import items from './items';
import orders from './orders';


export default {
  destroy,
  store,
  show,
  update,
  all,
  items,
  orders,
};



// WEBPACK FOOTER //
// ./src/app/services/productFlow/index.js